import React, { useRef, useEffect, useState } from 'react';
//import React, {useEffect } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import { SplitText } from "gsap/SplitText";
import { ScrollTo } from "gsap/ScrollToPlugin";
import { ScrollToPlugin } from '../js/ScrollToPlugin.min.js';
import { ScrollSmoother} from "../js/ScrollSmoother.min.js";




gsap.registerPlugin(SplitText, ScrollSmoother ,ScrollToPlugin);
// Define objects

 let tl_heading = gsap.timeline({});

const TransitionComponent = ({ children }) => {

 // window.scrollTo(0, 0);
  const location = useLocation();
    return (
      <SwitchTransition>
        <Transition
        key={location.pathname}
        timeout={500}
        onEnter={(node) => {



        let pageID = node.getAttribute('data-page-id');
        let pageIDClass = document.querySelector('.page-content');
        let mainbg = document.querySelector("#smooth-content");  



        



          // H1 HEADING TAG ANIMATION
           // Note this is in transitions.js and app.js both are modidifed copies of code
          let tlh1text = gsap.timeline({});
          
          // Preset
          gsap.set(".page-h1 h1", {x:"50px", autoAlpha: 0});
          gsap.set(".hero-text strong", {y:"50px", autoAlpha: 0});
          gsap.set(".h1-accent", {width:"0px"});
          // Animation
          tlh1text.to(".page-h1 h1", {x: "0px", autoAlpha:1, duration: 1, ease: "power4.out", onStart:herotxtfx})
          .to(".h1-accent", {width: "140px", duration: 1, ease: "power4.out",  })
          .to(".hero-text strong", {y:"0px", autoAlpha:1, duration: 1, ease: "power4.out", delay:-0.5,  });
      

     // SpliText FX
     let splitTitle = new SplitText(".page-h1 h1", {
      type: "words,chars"
    });
    let chars = splitTitle.chars; //an array of all the divs that wrap each character
  
    function herotxtfx() {
      gsap.from(chars, {
        duration: 0.2,
        opacity: 0,
        y: 10,
        ease: "none",
        delay:1,
        stagger: {
          each: 0.05,
          from: "random"
        }
      });
    }







   





  

// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// ANIMATE HERO
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

// ANIMATION - TRANSITTION SPLASH MASK
// -------------------------------------//
 // Preset it
 gsap.set("#dotmask" ,{scale:0});
 gsap.set("#hoopmask" ,{scale:0});
 
var tl_hero_trans = gsap.timeline({});
tl_hero_trans.to("#hoopmask", {scale:1, duration: 1.5, ease: "power4.out", delay:0.75})
.to("#dotmask", {scale:1, duration: 1.5, ease: "power4.out", delay:-1.75});


// ANIMATION - TRANSITTION SPLASH DOT - used to change the color, this is shown first.
// -------------------------------------//
var tl_bg_trans = gsap.timeline({});


if (pageID == 'home'){
  if (typeof sScroll !== 'undefined') {
       sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
     }else {
      window.scrollTo(0, 0);
     }
     // Preset
    gsap.set(".site-footer", {autoAlpha:1, overwrite: true}); // ()< Bug fix! need to add - overwrite: true since exit animation lingeres.
    pageIDClass.classList.remove("bg-home-fill");
    tl_bg_trans.to('.home-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}



if (pageID == 'portfolio'){
    if (typeof sScroll !== 'undefined') {
        sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
     }else {
      window.scrollTo(0, 0);
     }
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-portfolio-fill");
    tl_bg_trans.to('.portfolio-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}



if (pageID == 'services'){
     if (typeof sScroll !== 'undefined') {
     sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
      }else {
      window.scrollTo(0, 0);
     }
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-services-fill");
    tl_bg_trans.to('.services-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}


if (pageID == 'profile'){
      if (typeof sScroll !== 'undefined') {
        sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
      }else {
      window.scrollTo(0, 0);
      }
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-profile-fill");
    tl_bg_trans.to('.profile-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}


if (pageID == 'contact'){
    if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
     }else {
      window.scrollTo(0, 0);
    }
     // Preset
     gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
    pageIDClass.classList.remove("bg-contact-fill");
    tl_bg_trans.to('.contact-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
    .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}


if (pageID == 'archive'){

     if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
    }else {
      window.scrollTo(0, 0);
    }
  // Preset
  gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
 pageIDClass.classList.remove("bg-archive-fill");
 tl_bg_trans.to('.archive-transition-curtain', { left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 3.5, ease: "power4.out"})
 .to(this, {duration: 1, delay:"-2.5", onComplete:addBGfill});
}

if (pageID == 'portfolio-details'){

     if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
    }else {
      window.scrollTo(0, 0);
    }
  gsap.set(".site-footer", {autoAlpha:1, overwrite: true});
  // <<<<<<<<< =================================================  You need to add the animation/transition that shows the getDetails page here.
}



 // adds colored background 
 
function addBGfill(){
     // Remove all classes from element.
     mainbg.className = '';
     // add the fill color
     mainbg.classList.add("bg-"+pageID+"-fill");
    // hide the transition SVG
   document.querySelector("."+pageID+"-transition-curtain").style.display="none";
 }


 }} // END!













        // ==============================================
        // ON EXIT
        // ==============================================
        onExit={(node) => {

          // Animate Out
          // --------------//
          //let tl_heading = gsap.timeline({});

          gsap.set(node, {zIndex:1 });
          // 1) ANIMATE - fade out h1 tag and the enitre page of content and footer. 
          tl_heading.to(".page-h1", {x: "-50px", duration: 1, autoAlpha: 0, ease: "power4.out"})
        .to(".page-content", {duration: 0.75, autoAlpha: 0, ease: "power4.out", delay:-1 })
        .to(".site-footer", {duration: 0.5, autoAlpha: 0, ease: "power4.out", delay:-1 }); // need to set opacity to 1 at transitoning back in.
             
        
    

        }}>
        {children}
      </Transition>
    </SwitchTransition>
  );
};

export default TransitionComponent;
